<template>
 <div class="body">
<header>
  <h3><strong><router-link to="/" class="backlink"><svg class="svg-icon" viewBox="0 -3 20 20">
							<path fill="none" d="M8.388,10.049l4.76-4.873c0.303-0.31,0.297-0.804-0.012-1.105c-0.309-0.304-0.803-0.293-1.105,0.012L6.726,9.516c-0.303,0.31-0.296,0.805,0.012,1.105l5.433,5.307c0.152,0.148,0.35,0.223,0.547,0.223c0.203,0,0.406-0.08,0.559-0.236c0.303-0.309,0.295-0.803-0.012-1.104L8.388,10.049z"></path>
						</svg> back to main page</router-link></strong></h3>
  <h2>Computational Sciences</h2>
  <h4>Personal research website</h4>
</header>

<section>
  <nav>
    <h4>Research lines</h4>
    <ul>
      <li><router-link to="/">Face recognition algorithms</router-link></li>
      <li><router-link to="/">Math computational language</router-link></li>
      <li><router-link to="/">Task organization algorithms</router-link></li>

    </ul>
    <h4>Topics of interest</h4>
    <ul>
      <li><a href="#">Fractal geometry</a></li>
      <li><a href="#">Computational Number theory</a></li>
      <li><a href="#">Computational physics</a></li>
      <li><a href="#">Graphics computing</a></li>
    </ul>

    <small>
    <h4>Other research areas</h4>
      <a href="/philosophy">Philosophy</a> •
      <a href="/physics">Physics</a> •
      <a href="/computational_science">Computational Sciences</a>
    </small>
  </nav>

  <router-view/>

</section>

  <footerModule/>

</div>
</template>

<script>

import footerModule from '../components/footer.vue'

export default {
   name: 'Research_Philosophy',
   components: {footerModule}
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  background-color:rgb(63, 63, 63);
}

/* Style the header */
header {
  background-color: rgb(109, 64, 64);
  padding: 10px;
  text-align: center;
  font-size: 20px;
  color: white;
}

/* Create two columns/boxes that floats next to each other */
nav {
  float: left;
  width: 20%;
  height: 600px;
  background: #ccc;
  padding: 20px;
}

nav a{
  text-decoration: none;
}
nav a:hover{
  color: brown;
}


/* Style the list inside the menu */
nav ul {
  list-style-type: none;
  padding: 0;
}

article {
  float: left;
  padding: 20px;
  width: 70%;
  background-color: #f1f1f1;
  height: 70%;
}

/* Clear floats after the columns */
section::after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the two columns/boxes stack on top of each other instead of next to each other, on small screens */
@media (max-width: 600px) {
  nav, article {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Research_computation.vue